// extracted by mini-css-extract-plugin
export var curvedborder = "DogCardCarousel-module--curvedborder--8fa35";
export var fullwidth = "DogCardCarousel-module--fullwidth--54b3f";
export var pagination = "DogCardCarousel-module--pagination--bcffc";
export var swiper = "DogCardCarousel-module--swiper--ab248";
export var swiperwrapper = "DogCardCarousel-module--swiperwrapper--94106";